import { apiService } from "../../../../../components/api/apiService";

export const agentBuilderService = {
    /**
     * Start a new agentic chat session.
     * @param agentId The agent's ID
     * @param userId The user's ID
     * @param title Optional title for the session
     * @returns Promise resolving to { sessionId }
     */
    startNewSession: async (agentId: string, userId: string, title?: string) => {
        const queryParams = new URLSearchParams({
            agentId,
            userId,
            title: title || agentId,
        }).toString();

        return await apiService.post(`/api/AgenticChat/new-session?${queryParams}`, {}, 'backend');
    },
    startOrGetSession: async (agentId: string, userId: string, title?: string) => {
        const queryParams = new URLSearchParams({
            agentId,
            userId,
            title: title || agentId,
        }).toString();

        return await apiService.post(`/api/AgenticChat/start-or-get-session?${queryParams}`, {}, 'backend');
    },
    /**
     * Send a message in an active agent chat session.
     * @param payload Object with sessionId, userId, userMessage, and llmTypeId
     * @returns Promise resolving to LLM system response
     */
    sendMessage: async (payload: {
        sessionId: string;
        userId: string;
        userMessage: string;
        llmTypeId: string;
    }) => {
        return await apiService.post('/api/AgenticChat/SendMessage', payload, 'backend');
    },

    getAgentChatMessages: async (sessionId: string, agentId: string) => {
        const queryParams = new URLSearchParams({ sessionId, agentId }).toString();
        return await apiService.get(`/api/AgenticChat/messages?${queryParams}`, {}, 'backend');
    },

    /**
     * Get generated source code for an agent.
     * @param agentId Agent ID
     * @returns JSON object containing source code
     */
    getAgentSourceCode: async (agentId: string, builderType?: number) => {
        const params: { agentId: string; builderType?: string } = { agentId };
        if (builderType !== undefined) {
            params.builderType = builderType.toString();
        }
        const queryParams = new URLSearchParams(params).toString();
        return await apiService.get(`/api/AgenticChat/sourcecode?${queryParams}`, {}, 'backend');
    },
};
